module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8n5r1n-1a9f17a679e30e3ef2fd04120a814ce8.svg";